import { Component, Inject, Injector, Input, OnInit, Optional } from '@angular/core';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { ChargingPoint } from '@models/chargingPoint';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import { ChargingStationTableDto } from '@dto/chargingStationTableDto';
import { ChargingPointStatusEnum } from '@enums/chargingPointStatus.enum';

@Component({
  selector: 'charging-station-combined-status-badge',
  templateUrl: './charging-station-combined-status-badge.component.html',
  styleUrls: ['./charging-station-combined-status-badge.component.scss'],
})
export class ChargingStationCombinedStatusBadge implements OnInit {

  /** the charging station to display */
  @Input() chargingStation: ChargingStationTableDto;

  public unregistered: boolean;
  public offlineSinceText: string = '';

  /** Max number of extended pills. If above, everything will be shown as small circles. */
  private MAX_LARGE_PILLS: number = 2;

  constructor() {  }

  ngOnInit(): void {
    this.unregistered = (this.chargingStation.statusId == ChargingPointStatusEnum.Unregistered);
    if (this.chargingStation.statusId == ChargingPointStatusEnum.Offline && this.chargingStation.offlineSince) {
      var datePipe = new DEDatePipe();
      // '\u00A0' is a unicode non-breaking space, aka &nbsp;
      this.offlineSinceText = "\u00A0seit\u00A0" + datePipe.transform(this.chargingStation.offlineSince);
    }
  }

  getPillContent(chargingPoint: ChargingPoint): string {
    if (this.chargingStation.chargingPoints.length <= this.MAX_LARGE_PILLS) {
      return `${chargingPoint.status?.name}`;
    }
    return `${chargingPoint.connectorId}`;
  }

  getTooltip(chargingPoint: ChargingPoint): string {
    return ChargingStationsService.mapStatusTooltip(chargingPoint.statusId);
  }

  getBadgeClasses(chargingPoint: ChargingPoint): string {
    const badgeColorClass = this.getColorClassForStatus(chargingPoint.statusId)
    const connectorClass = `connector-id-${chargingPoint.connectorId}`;
    const pillStyleClasses = this.chargingStation.chargingPoints.length <= this.MAX_LARGE_PILLS
      ? 'rounded-pill'
      : 'rounded-circle me-1';
    return `badge p-2 ${pillStyleClasses} ${badgeColorClass} ${connectorClass}`;
  }

  getChargingStationBadgeClasses(): string {
    const badgeColorClass = this.getColorClassForStatus(this.chargingStation.statusId);
    return `badge p-2 rounded-pill ${badgeColorClass}`;
  }

  getColorClassForStatus(status: ChargingPointStatusEnum): string {
    switch (status) {
      case ChargingPointStatusEnum.Unregistered:  return 'bg-primary';
      case ChargingPointStatusEnum.Available:     return 'bg-success';
      case ChargingPointStatusEnum.Charging:      return 'bg-warning';
      case ChargingPointStatusEnum.Faulted:       return 'bg-danger';
      case ChargingPointStatusEnum.Finishing:     return 'bg-info';
      case ChargingPointStatusEnum.Preparing:     return 'bg-info';
      case ChargingPointStatusEnum.Reserved:      return 'bg-reserved';
      case ChargingPointStatusEnum.SuspendedEV:   return 'bg-info';
      case ChargingPointStatusEnum.SuspendedEVSE: return 'bg-info';
      case ChargingPointStatusEnum.Unavailable:   return 'bg-danger';
      case ChargingPointStatusEnum.Offline:       return 'bg-secondary';
      default:                                    return 'bg-secondary';
    }
  }
}
